import { useController } from 'react-hook-form';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { HAS_OTHER_REPLY } from './HoldUntilReply.constants';
import {
  CheckboxDescription,
  Caption,
  UnknownReplyCheckBoxContainer,
} from './HoldUntilReply.styles';

export const UNKNOWN_REPLY_EDGE_CHECKBOX_ID = 'unknown-reply-edge-checkbox-id';

export type UnknownReplyCheckBoxProps = {
  isReadOnly: boolean;
  onUnknownReplyChange: (checkboxValue: boolean) => void;
};

export const UnknownReplyCheckBox = ({
  onUnknownReplyChange,
  isReadOnly,
}: UnknownReplyCheckBoxProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name: HAS_OTHER_REPLY,
    defaultValue: false,
  });

  const handleChange = (checkboxValue: boolean) => {
    onChange(checkboxValue);
    onUnknownReplyChange(checkboxValue);
  };

  return (
    <UnknownReplyCheckBoxContainer>
      <Checkbox
        id={UNKNOWN_REPLY_EDGE_CHECKBOX_ID}
        data-test={UNKNOWN_REPLY_EDGE_CHECKBOX_ID}
        name={HAS_OTHER_REPLY}
        status={value ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED}
        onClick={() => handleChange(!value)}
        isDisabled={isReadOnly}
      />
      <CheckboxDescription>
        <span>Include an "Other reply" branch</span>
        <Caption>
          Users who send a reply that doesn't match any of your configured replies will go down this
          branch.
        </Caption>
      </CheckboxDescription>
    </UnknownReplyCheckBoxContainer>
  );
};
